import { HTMLAttributes, memo, ReactElement} from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    title:string;
    icon?:ReactElement;
    onClick?:any;
    children?:any
}

export function PlansList({title,icon,onClick,children}: Props): ReactElement {

    return (
        <div className="plans-list  col-12">
        <div className="plans-list-header">
          <span className="title">
              {title}
          </span>
        </div>
        <div className="plans-list-children custom-scrollbar">
        {children}
        </div>
      </div>
    )
}
export default memo(PlansList);